<template>
  <div class="container">
    <div class="frame">
      <PlaylistFrame :playlist="$store.deviceStartData.main_play_list" :playlist-type="'main'" />
    </div>
    <div class="infoscreen-container">
      <TicketPortrait
        v-if="tempTicket"
        ref="tempTicket"
        :style="{ display: showTempTicket ? 'flex' : 'none' }"
        :ticket="tempTicket"
      />
      <div
        v-for="(item, index) in currentItems"
        :key="item ? item.id : -(index + 1)"
        class="infoscreen-item"
        :style="{backgroundColor: $store.infoscreenData.infoboardBackgroundColor}"
      >
        <TicketPortrait
          v-if="item"
          ref="ticketRef"
          :ticket="item"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TicketPortrait from '../tickets/TicketPortrait';
import TemplateMixin from '../../mixins/TemplateMixin';
import PlaylistFrame from '../PlaylistFrame';

export default {
  name: 'TemplateGreed',
  components: {
    TicketPortrait,
    PlaylistFrame,
  },
  mixins: [TemplateMixin],
  computed: {
    currentItems() {
      return this.getCurrentTickets(3);
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
  display: flex;
  flex-direction: column;

  .frame {
    height: 607.5px;
    width: 100%;
  }

  .infoscreen-container {
    display: flex;
    flex-grow: 1;
    flex-wrap: wrap;

    .infoscreen-item {
      width: 100%;
      height: 33.333%;
      padding: 0 5.5vw;

      &:nth-child(1),
      &:nth-child(2) {
        border-bottom-width: max(0.417vw, 8px);
        border-bottom-style: solid;
        border-bottom-color: black;
      }
    }
  }
}

</style>
